<div class="question-page">
  <div class="question-page__content">
    <ng-content />
  </div>
  <div class="question-page__buttons u-flex-col-center">
    <div class="question-page__error">
      @if (disableNextButton) {
        <span class="ds-c-label alert-warning">{{ 'text.incompleteFormError' | translate }}</span>
      }
    </div>

    <div class="question-page__button-row u-flex-row-center">
      @if (showBackButton) {
        <app-button [buttonVariation]="'solid'" (buttonClickEvent)="backClick.emit()">
          {{ backLabelKey() | translate }}
        </app-button>
      }
      @if (showNextButton) {
        <app-button
          [buttonVariation]="'solid'"
          (buttonClickEvent)="nextClick.emit()"
          [disabled]="disableNextButton">
          {{ isCompleteStep ? (completeLabelKey() | translate) : (nextLabelKey() | translate) }}
        </app-button>
      }
    </div>
  </div>
</div>
